import * as React from 'react'
import * as Routes from 'routes'

interface JobApplicationCompleteContentProps {
  closeModal: VoidFunction;
  handleSaving: boolean;
}

export default class JobApplicationCompleteContent extends React.Component<JobApplicationCompleteContentProps, never> {
  render() {
    return (
      <>
        <button aria-label="Close" className="modal-close" data-dismiss="modal" type="button" onClick={this.props.closeModal} />
        <div className="interview-modal-title completed">応募が完了しました。</div>
        <div className="interview-modal-content">
          <header>今後の流れについて</header>
          <div className="next-step-list">
            <div className="next-step">
              <header>
                <div className="marker-container">
                  <div className="marker">1</div>
                </div>
                <div className="step-title">
                  <div className="main-title">職務経歴書のご提出</div>
                  <div className="required">（未提出の方は必須）</div>
                </div>
              </header>
              <section className="step-actions">
                <div className="step-action">
                  <header>【職務経歴書をお持ちの方】</header>
                  <a href={Routes.profile_sheet_resume_files_path()}>職務経歴書・ポートフォリオのアップロードページ</a>よりご提出をお願いいたします。
                </div>
                <div className="step-action">
                  <header>【職務経歴書をお持ちでない方】</header>
                  <a href={Routes.profile_sheet_resume_path()}>職務経歴書ページ</a>から記載をお願いいたします。
                </div>
              </section>
            </div>
            <div className="next-step-arrow">
              <i className="fas fa-chevron-down arrow-down"></i>
              <i className="fas fa-chevron-right arrow-right"></i>
            </div>
            <div className="next-step">
              <header>
                <div className="marker-container">
                  <div className="marker">2</div>
                </div>
                <div className="step-title">
                  <div className="main-title">企業にご推薦</div>
                </div>
              </header>
              <section className="step-actions">
                <div className="step-action important-text">
                  企業に推薦後ご面談依頼のあった場合のみ、職務経歴書提出後5営業日以内にご連絡いたします。
                </div>
              </section>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button disabled={this.props.handleSaving} type="button" className="close-modal" onClick={this.props.closeModal}>
            閉じる
          </button>
        </div>
      </>
    )
  }
}
